export default __webpack_public_path__ + "images/d5b7caa3fc25704091ecbf00f191e14d-folk_small.webp";